import React, {Component} from "react";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {Col, Row} from "reactstrap";
import {toast} from "react-toastify";

import {getEntity} from "../../../services/entity/entity-service";
import {playActiveSession} from "../../../services/game-session/game-session-service";
import {getActiveGameSessionId} from '../../../services/player/player-service'

import FormSection from "../../components/form-section/form-section";
import PlayerCard from "../../components/player-card/player-card";
import Button from "../../components/button/button";

import {getPlayers} from "../../../modules/player";
import {getSkills} from "../../../modules/system/skill";
import {setPageTitle} from "../../../modules/application/pages";
import {setMenu} from "../../../modules/application/menu";
import {parseQuery} from "../../../transformations/queryString"
import {getUser} from "../../../modules/user";
import {getAssignedPlayers, getMyPlayers} from "../../../modules/player";


import "./therapist-dashboard.css";

class TherapistDashboard extends Component {
    constructor(props) {
        super(props);
        this.getUser = getUser;
        this.getPlayers = getPlayers;
        this.state = {
            displayName: null,
            therapistId: null,
            therapistPlayers: [],
            assignedPlayers: [],
            initializing: true,
            playerSessions: [],
            playerResults: [],
            playerGameSessionActivityMap: [],
            playerActivePlayerGameSessionMap: [],
            playersToGameSessions: [],
            shouldSetTherapist: true,
            shouldSetTherapistByPlayers: true
        };

        this.setTherapist = this.setTherapist.bind(this);
        this.onClickPlayActiveSession = playActiveSession.bind(this)
    }

    componentWillMount() {
        const name = this.props.currentUserFirstName;
        this.props.dispatch(setPageTitle(`${name ? name : "Therapist"}'s Dashboard`));
        this.props.dispatch(setMenu("Therapist"));
        this.props.dispatch(getSkills());
        this.props.dispatch(getAssignedPlayers(this.props.token));
        this.props.dispatch(getMyPlayers(this.props.token));
    }

    componentDidMount() {
        const queryString = parseQuery(window.location);

        if (queryString && queryString.message) {
            const message = queryString.message;

            toast.success(unescape(message), {
                position: toast.POSITION.TOP_CENTER
            });

            if (queryString && queryString.auth) {
                localStorage.setItem("timocco.auth", decodeURI(queryString.auth));
            }
        }
    }

    componentDidUpdate() {
        const {currentUserId, currentUserFirstName} = this.props;
        const {displayName} = this.state;

        if (this.props.retrieved_assigned_players && this.props.retrieved_players && this.state.initializing) {          
            this.setState({initializing: false});
            if ((this.props.assigned_players.length > 0 && this.state.shouldSetTherapist) || (this.props.owned_players.length > 0 && this.state.shouldSetTherapistByPlayers)) {
                this.setTherapist(currentUserId);

                if (this.props.assigned_players.length > 0) {
                this.setState({
                    shouldSetTherapist: false
                });
                }

                if (this.props.owned_players.length > 0) {
                this.setState({
                    shouldSetTherapistByPlayers: false
                });
                }

            }
        }

        if (currentUserFirstName !== displayName) {
            this.props.dispatch(setPageTitle(`${currentUserFirstName}'s Dashboard`));
            this.setState({displayName: currentUserFirstName});
        }
    }

    async setTherapist(therapistId) {
        this.setState({therapistId});
        const {dispatch} = this.props;
        const user = await getEntity(dispatch, this.getUser(therapistId));
        const assignedPlayersWithOwnerName = this.props.assigned_players;

        const therapistPlayers = this.props.owned_players;

        let assignedPlayers = this.props.assigned_players;

        assignedPlayers = assignedPlayers.filter(player => player.owner_id !== therapistId);

        const playerIds = therapistPlayers.map(player => player.id);
        playerIds.push(...assignedPlayers.map(player => player.id));

        therapistPlayers.forEach(player => {
            player.owner_name = user.first_name + " " + user.last_name;
        });
        assignedPlayers.forEach(player => {
            for (let playerWithOwner in assignedPlayersWithOwnerName) {
              let currentPlayer = assignedPlayersWithOwnerName[playerWithOwner];
              if (currentPlayer.id === player.id) {
                player.owner_name = currentPlayer.owner_name
              }
            }
        });

        this.mapPlayerResults(playerIds);
        this.mapPlayerGameSessionActivities(playerIds);
        this.mapPlayerActivePlayerGameSession(playerIds);
        this.mapPlayersToGameSessions(playerIds);

        this.setState({therapistPlayers: therapistPlayers, assignedPlayers: assignedPlayers, therapistId: therapistId, initializing: false});
    }


    render() {

        let {currentUser} = this.props;


        if (currentUser.limited) {
            return (
                <div className='restore_limited_message'>This Page is not available on RESTORE Limited</div>
            );
        }
        else {
            return (
                <div className="px-1"><FormSection component={this.buildDashboard()}/></div>
            );
        }

        
    }

    buildDashboard = () => {
        const {therapistPlayers, assignedPlayers} = this.state;

        const hasPlayers = therapistPlayers && therapistPlayers.length > 0;
        const hasAssignedPlayers = assignedPlayers && assignedPlayers.length > 0;

        return <div className="m-0 p-0 container-fluid">
            <Row className="mx-1 my-1 p-0 text-left">
                <Link to="/player">
                    <Button size="sm" text="Add Player" color="info" outline/>
                </Link>
                <Link to="/gameSession">
                    <Button size="sm" className="ml-2" text="Design Session" color="info" outline/>
                </Link>
            </Row>
            {hasPlayers &&
            <Col md={12} className="ml-1 pl-0 pr-2 text-left">
                <FormSection
                    sectionLabel="My Players"
                    component={this.buildPlayerCards(therapistPlayers)}/>
            </Col>
            }
            {hasAssignedPlayers &&
            <Col md={12} className="ml-1 pl-0 pr-2 text-left">
                <FormSection
                    sectionLabel="Assigned Players"
                    component={this.buildPlayerCards(assignedPlayers)}/>
            </Col>
            }

            {!hasPlayers && !hasAssignedPlayers && this.state.initializing &&
              <div><i className='fa fa-spinner fa-spin'></i> Loading your players...</div>
            }
            {!hasPlayers && !hasAssignedPlayers && !this.state.initializing &&
            <Col md={12} className="ml-1 pl-0 pr-2 text-left">
                <FormSection
                    sectionLabel="My Players"
                    component={<h6 className="m-3 text-secondary">Add a new player to begin!</h6>}/>
            </Col>
            }
        </div>;
    };

    buildPlayerCards(players) {
        const {playerGameSessionActivityMap, playerActivePlayerGameSessionMap, playerResults} = this.state;

        return players && players.map(player => {
            const {token, currentUserId} = this.props;
            const {playersToGameSessions} = this.state;

            const activePlayerGameSession = playerActivePlayerGameSessionMap[player.id] || null;
            const gameSessions = playersToGameSessions[player.id];
            let activeGameSession;

            if (gameSessions) {
                const activeGameSessionId = getActiveGameSessionId(player);
                activeGameSession = gameSessions.find(gameSession => gameSession.id === activeGameSessionId)
            }

            return (
                <Col key={`player_card_${player.id}`} md="6" className="px-2 pt-2 pb-0">
                    <PlayerCard player={player}
                                activities={playerGameSessionActivityMap[player.id]}
                                activePlayerGameSession={activePlayerGameSession}
                                results={playerResults[player.id]}
                                skills={this.props.skills}
                                onClickPlayActiveSession={() => {
                                    this.onClickPlayActiveSession(player, token, currentUserId, null, null, true)
                                }}
                                token={token}
                                isReady={true}
                                activeGameSession={activeGameSession}
                    />
                    <br/>
                </Col>
            )
        });
    }

    mapPlayerResults = (playerIds) => {
        const playerResults = [];
        playerIds.forEach(playerId => {
            playerResults[playerId] = [];
        });

        // TODO: Add date filters to speed up dashboard page: result._created > current date - 7
    };

    mapPlayerActivePlayerGameSession = (playerIds) => {
        const playerActivePlayerGameSessionMap = [];
        playerIds.forEach(playerId => {
            playerActivePlayerGameSessionMap[playerId] = 0;
        });
    };

    mapPlayerGameSessionActivities = (playerIds) => {
        const playerGameSessionActivityMap = [];
        playerIds.forEach(playerId => {
            playerGameSessionActivityMap[playerId] = [];
        });
    };

    mapPlayersToGameSessions = (playerIds) => {
        const playersToGameSessions = [];
        playerIds.forEach(playerId => {
            playersToGameSessions[playerId] = [];
        });
    };
}

const withState = connect(state => {
    const {player, player_game_session, player_game_session_activity, result, skill, user} = state;

    return {
        players: player.players,
        owned_players: player.owned_players,
        retrieved_assigned_players: player.retrieved_assigned_players,
        retrieved_players: player.retrieved_players,
        assigned_players: player.assigned_players,
        skills: skill.skills,
        results: result.results,
        token: user.token,
        currentUser: user,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
        playerGameSessions: player_game_session.player_game_sessions,
        playerGameSessionActivities: player_game_session_activity.player_game_session_activities
    };
});
export default withRouter(withState(TherapistDashboard));



// WEBPACK FOOTER //
// ./src/components/containers/therapist-dashboard/therapist-dashboard.js